<template>
    <div>
        <v-dialog v-model="reviewerformdialog" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2 ml-4" v-on="on"
           >{{$t('pmreviewexercise.addreviewer')}}</v-btn>
          </template>
          <v-card>
            <v-card-title>
                <span class="headline">
                    {{ isEdit ? $t('pmreviewexercise.editreviewer') : $t('pmreviewexercise.addreviewer') }}
                </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :rules="[rules.required]"
                                :label="$t('pmreviewexercise.reviewertype')"
                                type="text"
                                :items="reviewerTypeList"
                                hide-selected
                                v-model="formData.pmreviewertypeid"
                                @change="changeReviewerTypeHandler(formData.pmreviewertypeid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :rules="[rules.required]"
                                :label="isEdit ? $t('pmreviewexercise.reviewerreadonly') : $t('appraisalrecord.reviewer') "
                                type="text"
                                :items="staffList"
                                hide-selected
                                :readonly="isEdit"
                                v-model="formData.reviewerid"
                                @change="changeReviewerHandler(formData.reviewerid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.staffno')"
                                type="text"
                                v-model="formData.staffcode"
                                dense
                                background-color="#ffeab2"
                                readonly
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                 :label="$t('columns.company')"
                                type="text"
                                v-model="formData.staffcompany"
                                dense
                                background-color="#ffeab2"
                                readonly
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :rules="[rules.required]"
                                :label="$t('appraisalrecord.reviewfrom')"
                                type="date"
                                v-model="formData.reviewfromdate"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :rules="[rules.required]"
                                :label="$t('appraisalrecord.reviewuntil')"
                                type="date"
                                v-model="formData.reviewuntildate"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :rules="[rules.required]"
                                :label="$t('appraisalrecord.factor')"
                                type="number"
                                v-model="formData.factor"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                        <v-col v-if="isEdit" cols="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('Setupratingscaleset.score')"
                                type="number"
                                v-model="formData.score"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.form')"
                                type="text"
                                :rules="[rules.required]"
                                :items="reviewFormList"
                                hide-selected
                                v-model="formData.pmreviewformid"
                                dense
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                 :label="$t('columns.status')"
                                type="text"
                                :rules="[rules.required]"
                                :items="statusList"
                                hide-selected
                                v-model="formData.pmstatusid"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
            </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveReviewerForm">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeReviewerForm">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <v-row class="ml-1">
            <v-col cols="12" class="review-stats-label" style="display:flex;align-items:center;padding-top:8px;padding-bottom:8px;padding-left:16px;">
                {{$t('appraisalrecord.reviews')}}
            </v-col>
        </v-row>

        <v-container v-if="!loading" class="overflow-y-auto px-4">
            <v-row>
                <v-col cols="12" sm="12">
                    <div style="overflow-x: auto; width: 100%;">
        <v-data-table
                        :headers="this.parentObject.tabHeader"
                        :items="detailItem"
                        class="elavation-1"
:sort-by="['code']"
                    >
                        <template v-slot:[`item.action`]="{ item }">
                            <div class="d-flex align-center">
                                <img 
                                    :src="`${publicPath}images/paper.svg`" 
                                    alt="SVG Icon" 
                                    @click="onAdvanceEditItem(item)" 
                                    style="width: 15px; height: 18px; cursor: pointer;"
                                    class="mb-1"
                                />
                                <v-icon
                                    small
                                    class="ml-2 mr-2"
                                    @click="modifyItemHandler(item)"
                                >
                                    mdi-pen
                                </v-icon>
                                <v-icon
                                    small
                                    class="mr-2"
                                    @click="deleteItemHandler(item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </div>
                        </template>

                        <div v-if="isErr">
                        <app-error
                            v-bind:parentError="{
                            data: this.errMsg,
                            isErr: this.isErr,
                            }"
                            v-on:closeError="isErr = $event"
                        />
                        </div>

                    </v-data-table>
        </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import moment from "moment";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            publicPath: process.env.BASE_URL,

            reviewerformdialog: false,
            detailItem: this.parentObject.detailItem,
            staffData: this.parentObject.staffData,
         
            formData: {
                pmreviewexercisedid : this.parentObject.pmreviewexercisedid,
                pmreviewertypeid : null,
                reviewerid : null,
                staffcode : null,
                staffcompany : null,
                reviewfromdate : null,
                reviewuntildate : null,
                factor : 0,
                score : null,
                pmreviewformid : null,
                pmstatusid : null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            reviewerType: [],
            reviewerTypeList: [],
            staffFull: [],
            staffList: [],
            status: [],
            statusList: [],

            reviewForm: [],
            reviewFormList: [],

            reviewerList: [],

            isEdit: false,
            loading: true,

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',
        }
    },

    methods: {
        async loadReviewer() {
            const vm = this;

            // Dispatch the post request with the payloads object
            await this.$store.dispatch('get', {url: "/reviewexercisestaff/reviewer/" + this.parentObject.pmreviewexercisedid})
            .then((res) => {
            if (res.status == 200) {
                for (let i = 0; i < res.data.rec.length; i++) {
                    if (res.data.rec[i].reviewfromdate) {
                        res.data.rec[i].reviewfromdate = moment(res.data.rec[i].reviewfromdate).format('YYYY-MM-DD');
                    }
                    if (res.data.rec[i].reviewuntildate) {
                        res.data.rec[i].reviewuntildate = moment(res.data.rec[i].reviewuntildate).format('YYYY-MM-DD');
                    }
                }
                vm.detailItem = res.data.rec;
                vm.loading = false;
            } else {
                vm.isErr = !vm.isErr;
            }
            })
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });

        },

        loadReviewerType() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewertype/all"})
            .then(function (res) {
                vm.reviewerType = res.data.rec;
        
                for (let i = 0; i < vm.reviewerType.length; i++) {
                    vm.reviewerTypeList.push({
                    text: vm.reviewerType[i].reviewertypename,
                    value: vm.reviewerType[i].id, 
                    });
                }
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        loadStaffList(){
            const vm = this;
            const today = new Date();

            this.$store.dispatch('get', {url: "/staff/all/" + this.$store.getters.userId})
            .then((res) => {

                const staffRecords = res.data.rec;

                // Filter staff records where cessadate > today's date
                const filteredStaff = staffRecords.filter(staff => {
                    const cessadate = new Date(staff.cessadate);
                    return cessadate > today;
                });

                if (this.isEdit == false){
                    const detailItemStaffIds = vm.detailItem.map(item => item.reviewerid);

                    const uniqueStaff = filteredStaff.filter(staff => {
                        return !detailItemStaffIds.includes(staff.id) && !this.parentObject.staffcode.includes(staff.staffcode);
                    });
                    vm.staffFull = uniqueStaff;

                    // Populate staffList with the filtered data
                    vm.staffList = uniqueStaff.map(staff => ({
                        text: staff.psndetails,
                        staffcode: staff.staffcode,
                        staffcompany: staff.compnyname,
                        value: staff.id,
                    }));
                } else{
                    vm.staffFull = filteredStaff;

                    // Populate staffList with the filtered data
                    vm.staffList = filteredStaff.map(staff => ({
                        text: staff.psndetails,
                        staffcode: staff.staffcode,
                        staffcompany: staff.compnyname,
                        value: staff.id,
                    }));
                }
                
            }).catch((err) => {
                console.error(err)
            });

        },

        changeReviewerHandler(id) {
            let item = this.staffList.find(item => item.value == id);
            this.formData.staffcode = item.staffcode;
            this.formData.staffcompany = item.staffcompany;
        },

        changeReviewerTypeHandler(id) {
            if (id == 1) {
                this.formData.factor = 1;
            } else {
                this.formData.factor = 0;
            }
        },

        loadStatus() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewexercise/status/all"})
            .then(function (res) {
                vm.status = res.data.rec;
        
                for (let i = 0; i < vm.status.length; i++) {
                    vm.statusList.push({
                    text: vm.status[i].statusdesc,
                    value: vm.status[i].id,
                    });
                }
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        loadReviewForm() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewform/active/all"})
            .then(function (res) {
                vm.reviewForm = res.data.rec;
        
                for (let i = 0; i < vm.reviewForm.length; i++) {
                    vm.reviewFormList.push({
                    text: vm.reviewForm[i].formcode,
                    value: vm.reviewForm[i].id,
                    });
                }

                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        onAdvanceEditItem(item) {
            this.$router.push({name: 'reviewexerciseitem', params: {id: item.id, item: item, staffData: this.staffData, pmreviewexercisedid: this.parentObject.pmreviewexercisedid, method: this.parentObject.method}});
        },

        modifyItemHandler(item) {
            this.isEdit = true;
            this.formData = {
                pmreviewexercisedid : item.reviewexercisedid,
                pmreviewertypeid : item.reviewertypeid,
                reviewerid : item.reviewerid,
                staffcode : item.staffcode,
                staffcompany : item.compnyname,
                reviewfromdate : item.reviewfromdate,
                reviewuntildate : item.reviewuntildate,
                factor : item.factor,
                score : item.score,
                pmreviewformid : item.reviewformid,
                pmstatusid : item.statusid,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
            this.reviewerformdialog = true;
        },

        deleteItemHandler(item) {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('pmreviewexercise.deletereviewer') )) {
                this.$store.dispatch('delete', {url: "/reviewexercisestaff/reviewer/" + item.id})
                .then(function () {
                    const index = vm.detailItem.findIndex(detail => detail.id === item.id);
                    if (index !== -1) {
                        vm.detailItem.splice(index, 1);
                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
            }
        },

        async saveReviewerForm() {
            const vm = this;

            if (this.isEdit) { // Edit
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                try {
                    const res = await this.$store.dispatch('put', {url: "/reviewexercisestaff/reviewer/" + this.formData.id, payload: this.formData});
                    
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = Array.isArray(res.data.error) ? 
                            res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n') : res.data.error;
                    } else {
                        await this.loadReviewer(); 
                        this.reviewerformdialog = false;
                        this.isEdit = false;
                        this.resetSelections();
                    }
                } catch (err) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                }
            } else { // Add
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                try {
                    const res = await this.$store.dispatch('post', {url: "/reviewexercisestaff/reviewer/create", payload: this.formData});
                    
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = Array.isArray(res.data.error) ? 
                            res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n') : res.data.error;
                    } else {
                        await this.loadReviewer(); // Call loadReviewer after adding
                        this.reviewerformdialog = false;
                        this.resetSelections();
                    }
                } catch (err) {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                }
            }
        },


        closeReviewerForm() {
            this.reviewerformdialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.formData = {
                pmreviewexercisedid : this.parentObject.pmreviewexercisedid,
                pmreviewertypeid : null,
                reviewerid : null,
                staffcode : null,
                staffcompany : null,
                reviewfromdate : null,
                reviewuntildate : null,
                factor : null,
                score : null,
                pmreviewformid : null,
                pmstatusid : null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },  
    },

    async created() {
        await this.loadReviewer();
        this.loadReviewerType();
        this.loadStaffList();
        this.loadReviewForm();
        this.loadStatus();
    },

    mounted() {
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>